import React, {useContext} from 'react';
import MobXContext from "../../../app/mobx/MobXContext";
import {observer} from "mobx-react";
import IconSimpleInput from "./IconSimpleInput/IconSimpleInput";

const propTypes = {};
const defaultProps = {};

const HeaderLogoInput = () => {
	/*
	 * @param {*} headerLogo - SVG, Function, Dom Node, or Image URL
	 * @param {string} headerLogoType - The type of headerLogo, see See ICON_TYPES enum
	 */
	const {configuratorStore} = useContext(MobXContext);

	return (
		<div className="configurator__inputs__input">
			<IconSimpleInput
				label="Header Logo"
				popOverTextKey="headerLogo"

				altText={configuratorStore.headerLogoAltText}
				domValue={configuratorStore.headerLogoDom}
				functionValue={configuratorStore.headerLogoFunction}
				iconType={configuratorStore.headerLogoType}
				stringValue={configuratorStore.headerLogoString}
				urlValue={configuratorStore.headerLogoUrl}

				onAltTextChange={value => configuratorStore.setFieldValue('headerLogoAltText', value)}
				onDomValueChange={value => configuratorStore.setFieldValue('headerLogoDom',value)}
				onFunctionValueChange={value => configuratorStore.setFieldValue('headerLogoFunction', value)}
				onStringValueChange={value => configuratorStore.setFieldValue('headerLogoString', value)}
				onTypeChange={value => configuratorStore.setFieldValue('headerLogoType', value)}
				onUrlValueChange={value => configuratorStore.setFieldValue('headerLogoUrl', value)}
			/>
		</div>
	);
};

HeaderLogoInput.propTypes = propTypes;
HeaderLogoInput.defaultProps = defaultProps;

export default observer(HeaderLogoInput);
